import { motion } from "framer-motion";

const items = [
  { value: "20+", label: "Years in IT" },
  { value: "15+", label: "Years training" },
  { value: "5,000+", label: "Professionals trained" },
  { value: "50+", label: "Enterprise clients" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden">
        {items.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="bg-[#0A0C13] p-7 md:p-9"
          >
            <div className="font-display font-extrabold text-3xl md:text-5xl text-white tracking-tighter">
              {s.value}
            </div>
            <div className="mt-2 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
